import { FC } from 'react';
import { Card as MuiCard, CardContent, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FilterLiveSearch } from 'react-admin';
import PlanFilter from '../../component/PlanFilter';
import DateSideFilter from './DateSideFilter';

const Card = withStyles((theme) => ({
  root: {
    flexShrink: 0,
    [theme.breakpoints.up('sm')]: {
      order: -1,
      width: '15em',
      marginRight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))(MuiCard);

const SubscriptionsAside: FC = () => (
  <Card>
    <CardContent>
      <Typography variant="body2" style={{ color: 'grey' }}>
        Search by Name, Email
      </Typography>
      <FilterLiveSearch source={'searchKey'} />
      <PlanFilter />
      <DateSideFilter />
    </CardContent>
  </Card>
);

export default SubscriptionsAside;
